import React from 'react';

const SvgTripStart = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 96 96" ref={svgRef} {...props} fill="currentColor">
    <title>{title}</title>
    <path d="M34.5 1.4c-13.1 4.3-23 13.4-27.1 24.8-2.2 6.1-1.9 17.3.5 24.2 3.2 9.2 12.5 22.1 24.7 34.3C43.3 95.5 44 96 48 96s4.7-.5 15.4-11.3c12.2-12.2 21.5-25.1 24.7-34.4 2.9-8 2.4-20.8-.9-27.5-3.9-7.9-10.5-14.3-19-18.5C61 .7 60.1.5 49.6.3 42.5.1 37.1.5 34.5 1.4zM66 25.7c0 2.1-13.5 35.2-14.9 36.6-1.7 1.7-3-.3-5.2-7.3-1.1-3.8-2.6-7.4-3.3-7.9-.7-.6-4.2-2-7.9-3.1-6.8-2.1-8.6-3.5-7-5.1 1.5-1.5 33.6-14.7 36.1-14.8 1.5-.1 2.2.5 2.2 1.6z" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgTripStart svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/TripStart.js